import styled from 'styled-components'
import tw from 'twin.macro'

const Body = styled.div`
	color: ${(props) => props.theme.textColor};
	width: ${(props) => props.width || '100%'};
	height: ${(props) => props.height};
	min-height: ${(props) => props.minHeight};
	max-height: ${(props) => props.maxHeight};
	background-color: ${(props) => props.theme.cardBg};
	border-radius: 16px;
	border: 1px solid ${props => props.theme.purpleBorder} ;
	/* margin-top: ${(props) => props.marginTop || '25px'}; */
    padding: 32px;
	/* box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16); */
	position: relative;
	transition: all 0.3s;

`

const Header = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	height:20px;
	margin-bottom: 16px;
`

const Title = styled.div`
	color: ${(props) => props.theme.textColor};
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 12px;
	/* letter-spacing: 1.5px; */

	@media screen and (max-width: 480px) {
		font-size: 0.7rem;
	}
`

export { Body, Title, Header }
